import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  SwipeableDrawer,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  Box,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import PageTitle from "../../components/PageTitle";
import { toast } from "react-toastify";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "../../css/candidate-profile.css";
import { useHistory } from "react-router-dom";
import ViewIcon from "@material-ui/icons/Visibility";
import { Controller } from "react-hook-form";
import countries from "../../images/files/phone_country_code.json"; // adjust path
import { Alert, AlertTitle } from "@material-ui/lab";

export default function DuplicateCheckCandidates(props) {
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const positions = [toast.POSITION.TOP_RIGHT];

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [secureCandiData, setSecureCandiData] = useState([]);
  const [viewSecureCandiData, setViewSecureCandiData] = useState(null);
  const [activeModal, setActiveModal] = useState(false);

  var [notificationsPosition] = useState(2);
  var [errorToastId, setErrorToastId] = useState(null);
  const [isCandidateNew, setIsCandidateNew] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [alertMessage, setAlertMessage] = useState(null);

  const handleOpenModal = (value, type) => {
    setViewSecureCandiData(value);
    setActiveModal(type);
  };

  const handleCloseModal = () => {
    setViewSecureCandiData(null);
    setActiveModal(null);
  };

  useEffect(() => {
    // load from local json
    const sortedData = countries.sort((a, b) =>
      a.country_en.localeCompare(b.country_en),
    );
    setCountryList(sortedData);
  }, []);

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const validationSchema = Yup.object().shape({
    candidateName: Yup.string().required("Missing Name"),
    candidateEmail: Yup.string().required("Missing Email"),
    candidateMobile: Yup.string().required("Missing Mobile"),
  });

  const {
    register,
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      countryCode: 91,
    },
  });

  useEffect(() => {
    fetchData({ page });
    const storedValue = localStorage.getItem("duplication-check-global");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async ({ page }) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}candidateEntryGroup/vendor/getAllGroups`,
      data: {
        page: page,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          setLoader(false);
          setSecureCandiData(response.data.data);
          setCount(response.data.count);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  async function handleCheckCandidateDuplication(values) {
    try {
      setLoader(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}duplicateCheck`,
        data: {
          candidateEmail: values.candidateEmail,
          countryCode: values.countryCode,
          candidateMobile: values.candidateMobile,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      setLoader(false);

      if (response.data.status) {
        setIsCandidateNew({
          ...values,
          candidateEntryGroupId: viewSecureCandiData.id,
        });
        // handleNotificationCall("success", response.data.message);
        setAlertMessage({
          type: "success",
          title: "Success",
          message: response.data.message,
        });
      } else {
        setIsCandidateNew(null);
        setAlertMessage({
          type: "info",
          title: "Info",
          message: "This profile already exists",
        });
        // handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleSaveCandidate = async () => {
    if (!isCandidateNew) {
      return;
    }

    try {
      setLoader(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}duplicateCheck/vendor/saveNew`,
        data: {
          ...isCandidateNew,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      setLoader(false);

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        reset();
        setIsCandidateNew(null);
        handleCloseModal();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  var table_data = {};

  var table_columns = [];

  table_columns = [
    {
      name: "S.No",
    },
    {
      name: "Date",
    },
    {
      name: "Title",
    },
    {
      name: "Action",
    },
    {
      name: "Last Updated Date",
    },
  ];

  table_data = secureCandiData.map((item, index) => {
    return [
      <>{page !== 0 ? 10 * page - 10 + index + 1 : index + 1}</>,
      moment(item.createdAt).format("DD-MM-YYYY"),
      item.groupName,
      <>
        <Grid container className={classes.space}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            onClick={() => handleOpenModal(item, "add-candidate")}
          >
            Post Candidates
          </Button>

          <Tooltip title="View Candidates" placement="bottom" aria-label="view">
            <ViewIcon
              className={classes.toolIcon}
              onClick={() => {
                window.open(
                  `/app/checking_candidates?groupId=${item.id}`,
                  "_blank",
                  "noopener,noreferrer",
                );
              }}
            />
          </Tooltip>
        </Grid>
      </>,
      moment(item.updatedAt).format("DD-MM-YYYY"),
    ];
  });

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Check Duplicate Candidate" />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title={""}
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              print: false,
              download: false,
              // customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={table_columns}
            data={table_data}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleCloseModal}
        open={activeModal === "add-candidate"}
        width="sm"
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          Check Candidate Duplication
        </DialogTitle>
        <DialogContent>
          {alertMessage && (
            <Alert variant="filled" severity={alertMessage.type}>
              <AlertTitle style={{ color: "#fff" }}>
                {alertMessage.title}
              </AlertTitle>
              {alertMessage.message}
            </Alert>
          )}
          <form onSubmit={handleSubmit(handleCheckCandidateDuplication)}>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <Grid item xs={12}>
                <InputLabel shrink htmlFor="candidateName">
                  Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    size="small"
                    placeholder="Candidate Name"
                    name="candidateName"
                    {...register("candidateName")}
                    error={errors.candidateName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.candidateName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <InputLabel shrink htmlFor="candidateEmail">
                  Email Id
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    size="small"
                    placeholder="Candidate Email Id"
                    name="candidateEmail"
                    type="email"
                    {...register("candidateEmail")}
                    error={errors.candidateEmail ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.candidateEmail?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <InputLabel shrink htmlFor="candidateMobile">
                  Mobile Number
                </InputLabel>
                <Box sx={{ display: "flex", gap: "4px" }}>
                  <FormControl style={{ width: "max-content" }}>
                    <Controller
                      name="countryCode"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          options={countryList}
                          getOptionLabel={(option) =>
                            `(+${option.phone_code}) / ${option.country_en}`
                          }
                          value={
                            countryList.find((c) => c.phone_code === value) ||
                            null
                          }
                          onChange={(_, newValue) => {
                            onChange(newValue ? newValue.phone_code : "");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select country code"
                              InputProps={{
                                ...params.InputProps,
                                style: { marginTop: "4px" }, // 👈 This applies to the filled input container
                              }}
                              error={!!errors?.countryCode}
                              helperText={errors?.countryCode?.message}
                              variant="filled"
                            />
                          )}
                        />
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors?.countryCode?.message}
                    </Typography>
                  </FormControl>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Candidate Mobile Number"
                      name="candidateMobile"
                      {...register("candidateMobile")}
                      error={errors.candidateMobile ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.candidateMobile?.message}
                    </Typography>
                  </FormControl>
                </Box>
              </Grid>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "6px",
                  width: "100%",
                  margin: "10px 0px",
                }}
              >
                {isCandidateNew && (
                  <Button
                    variant="contained"
                    className={classes.green}
                    size="small"
                    onClick={handleSaveCandidate}
                    type="button"
                  >
                    Save Candidate
                  </Button>
                )}

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  type="submit"
                >
                  Check Candidate
                </Button>
              </div>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {/* {list("right")} */}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
